import classes from './Room.module.css';
import logo from "../../../store/Fairmont_logo.png"
import {Fragment, useEffect, useState} from "react";
import defScreen from "../../../store/Fairmont_logo.png"
import axios from "axios";
import { path, assetsBaseUrl } from "../../../routes";

/** Radisson Blu – když na displeji neběží meeting, zobrazit tuto fotku */
const RADISSON_BLU_ORG_ID = 'AC9D7FD5-E333-4B1E-9043-4697568313B7';
const RADISSON_BLU_NO_MEETING_IMAGE = 'uploads/thumbnail_image004.bfa3ed51f067a583ce0a.png';

const RoomFairmont = (props) => {
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");
    const [roomName, setroomName] = useState(props.roomName);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [roomtext, setroomText] = useState(props.text);
    const [roomID, setroomID] = useState(props.roomId);
    const [meeting_ob, setMeeting_ob] = useState(false);
    const [logoHeader , setLogoHeader] = useState();
    const [isRunning, setIsRunning] = useState(false);
    const [meetingData, setMeetingData] = useState(null);
    const [backgroundColor, setBackgroundColor] = useState('#012e5f');
    const [roomNameColor, setRoomNameColor] = useState('#ffffff');
    const [meetingTitleColor, setMeetingTitleColor] = useState('#000000');
    const [showLogo, setShowLogo] = useState(true);
    const [showTitle, setShowTitle] = useState(true);
    const [showTimeRange, setShowTimeRange] = useState(false);
    const [slideshowPriority, setSlideshowPriority] = useState(false);
    const [deviceRoomGroup, setDeviceRoomGroup] = useState(null);
    const [slideshowCards, setSlideshowCards] = useState([]);
    const [slideshowIndex, setSlideshowIndex] = useState(0);
    const [slideIntervalSec, setSlideIntervalSec] = useState(15);
    const [objectFitSlideshow, setObjectFitSlideshow] = useState('contain');
    const [deviceDescription, setDeviceDescription] = useState(null);
    const [deviceOrgId, setDeviceOrgId] = useState(null); // org z backendu – pro načtení slideshow i bez org v URL
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    // const actTime = `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
    //const actDate = `${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`;
    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }
    const getOrg = async (org) => {
        const o = org ?? props.org;
        if (!o) return;
        try {
            const response = await axios.get(`${path}/getOrganization/${o}`);
            if (response.data && response.data.length > 0) {
                setLogoHeader(assetsBaseUrl + response.data[0].logoPath);
            }
        } catch (error) {
            // ignore
        }
    };
    useEffect(() => {
        const deviceId = roomID;
        const orgId = props.org || deviceOrgId;
        if (deviceId) {
            let url = orgId ? `${path}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}` : `${path}/getDeviceSettings/${deviceId}`;
            if (refreshTrigger > 0) url += (url.includes('?') ? '&' : '?') + `_t=${refreshTrigger}`; // cache-bust po změně
            axios.get(url)
                .then((r) => {
                    const s = r.data?.settings || {};
                    if (s.backgroundColor) setBackgroundColor(s.backgroundColor);
                    else setBackgroundColor('#012e5f');
                    if (s.roomNameColor) setRoomNameColor(s.roomNameColor);
                    else if (s.textColor) setRoomNameColor(s.textColor);
                    else setRoomNameColor('#ffffff');
                    if (s.meetingTitleColor) setMeetingTitleColor(s.meetingTitleColor);
                    else if (s.textColor) setMeetingTitleColor(s.textColor);
                    else setMeetingTitleColor('#000000');
                    if (typeof s.showLogo === 'boolean') setShowLogo(s.showLogo);
                    if (typeof s.showTitle === 'boolean') setShowTitle(s.showTitle);
                    if (typeof s.showTimeRange === 'boolean') setShowTimeRange(s.showTimeRange);
                    else setShowTimeRange(false);
                    if (typeof s.slideshowPriority === 'boolean') setSlideshowPriority(s.slideshowPriority);
                    else setSlideshowPriority(false);
                    if (typeof s.slideIntervalSec === 'number') setSlideIntervalSec(Math.max(3, Math.min(300, s.slideIntervalSec)));
                    if (s.objectFit === 'cover' || s.objectFit === 'contain') setObjectFitSlideshow(s.objectFit);
                    const rg = r.data?.deviceRoomGroup;
                    const parsed = (rg != null && rg !== undefined && Number.isFinite(Number(rg)) && Number(rg) >= 0) ? Math.floor(Number(rg)) : null;
                    setDeviceRoomGroup(parsed);
                    const name = r.data?.deviceDescription;
                    setDeviceDescription(name != null && String(name).trim() ? String(name).trim() : null);
                    if (r.data?.deviceOrgId) setDeviceOrgId(r.data.deviceOrgId);
                })
                .catch(() => {});
        }
    }, [roomID, props.org, refreshTrigger]);

    const effectiveOrg = props.org || deviceOrgId;

    // Načíst karty slideshow pro skupinu displeje; při odebrání ze skupiny (gr null) vymazat fotky
    useEffect(() => {
        const gr = deviceRoomGroup;
        if (gr == null || gr === undefined || Number(gr) <= 0 || !effectiveOrg) {
            setSlideshowCards([]);
            setSlideshowIndex(0);
            return;
        }
        let cancelled = false;
        const cardsUrl = `${path}/getCardsV3?orgID=${effectiveOrg}&group=${gr}&onlyVisible=1&device_group=1${refreshTrigger > 0 ? `&_t=${refreshTrigger}` : ''}`;
        axios.get(cardsUrl)
            .then((res) => {
                if (cancelled) return;
                const raw = Array.isArray(res.data) ? res.data : [];
                const urls = raw.filter(c => c && c.path).map(c => assetsBaseUrl + c.path);
                setSlideshowCards(urls);
                setSlideshowIndex(0);
            })
            .catch(() => {
                if (!cancelled) setSlideshowCards([]);
            });
        return () => { cancelled = true; };
    }, [deviceRoomGroup, effectiveOrg, refreshTrigger]);

    // Posun slideshow při „no meeting“
    useEffect(() => {
        if (slideshowCards.length <= 1) return;
        const intervalMs = Math.max(3000, (slideIntervalSec || 15) * 1000);
        const id = setInterval(() => {
            setSlideshowIndex((prev) => (prev + 1) % slideshowCards.length);
        }, intervalMs);
        return () => clearInterval(id);
    }, [slideshowCards.length, slideIntervalSec]);

    useEffect(() => {
        getOrg(effectiveOrg);
        // Funkce, která se spustí každou minutu

        const hourDelay =60 *  15 * 1000; // 1 hour in milliseconds
       // const refreshPage = setTimeout(() => {
       //     window.location.reload();
        //}, hourDelay);

        const resetVal = async (org) => {
            try {
                await axios.post(`${path}/updateReset/${roomID}`, org ? { orgID: org } : {});
            } catch (_) {}
        };
        const getReset = async () => {
            try {
                const orgParam = effectiveOrg ? `?orgID=${encodeURIComponent(effectiveOrg)}` : '';
                const response = await axios.get(`${path}/getReset/${roomID}${orgParam}`);
                const need = response.data?.[0]?.needUpdate;
                if (need === 1 || need === true) {
                    console.log("[RoomFairmont] Změna nastavení – obnovuji data bez reloadu");
                    await resetVal(effectiveOrg);
                    setRefreshTrigger((t) => t + 1);
                }
            } catch (error) {
                // ignore
            }
        };


        const send = async () =>{
            try {
                const currentTime = getTime();
                // Use query parameter endpoint directly for production (dev.csgcontrols.cz) due to IIS routing issues
                const useQueryEndpoint = path.includes('dev.csgcontrols.cz') || path.includes('csgcontrols.cz');
                const url = useQueryEndpoint 
                    ? `${path}/getMeetingQuery?id=${roomID}&day=${encodeURIComponent(currentTime)}`
                    : `${path}/getMeeting/${roomID}/${encodeURIComponent(currentTime)}`;
                console.log('[RoomFairmont] Fetching meeting:', { roomID, currentTime, url, useQueryEndpoint });
                const response = await axios.get(url);
                const data = Array.isArray(response.data) ? response.data : [];
                console.log('[RoomFairmont] Meeting response:', { roomID, dataLength: data.length, data });
                if (data.length > 0) {
                    const rec = data[0];
                    console.log('[RoomFairmont] Found meeting:', { 
                        id: rec.id, 
                        description: rec.description, 
                        dateFrom: rec.dateFrom, 
                        dateTo: rec.dateTo,
                        path: rec.path 
                    });
                    setroomText(rec.description ?? '');
                    // Cache-busting: přidat časový parametr, aby se po změně loga akce načetla nová verze obrázku
                    setLogoOrg(rec.path ? `${assetsBaseUrl}${rec.path}?t=${Date.now()}` : null);
                    setMeetingData(rec);
                    
                    // Check if meeting is currently running
                    const now = new Date().getTime();
                    const dateFrom = new Date(rec.dateFrom).getTime();
                    const dateTo = new Date(rec.dateTo).getTime();
                    const running = dateFrom <= now && now <= dateTo;
                    setIsRunning(running);
                } else {
                    console.log('[RoomFairmont] No meeting found for roomID:', roomID, 'at time:', currentTime);
                    setLogoOrg(null);
                    setroomText(null);
                    setMeetingData(null);
                    setIsRunning(false);
                }
            }
            catch (error){
                console.error('[RoomFairmont] Error fetching meeting:', error);
                console.error('[RoomFairmont] Error details:', { 
                    message: error.message, 
                    response: error.response?.data,
                    status: error.response?.status,
                    roomID 
                });
                setLogoOrg(null);
                setroomText(null);
                setMeetingData(null);
                setIsRunning(false);
            }
        }



        const updateMinute = () => {
            let dt = new Date();
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`);
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`);
            
            // Update running status every second
            if (meetingData) {
                const now = new Date().getTime();
                const dateFrom = new Date(meetingData.dateFrom).getTime();
                const dateTo = new Date(meetingData.dateTo).getTime();
                setIsRunning(dateFrom <= now && now <= dateTo);
            }
        };
        updateMinute();
        send();
        getReset(); // kontrola hned po načtení
        const intervalId = setInterval(updateMinute, 1000);
        const intervalId2 = setInterval(send, 5 * 1000);
        const intervalId3 = setInterval(getReset, 3 * 1000); // každé 3 s, aby změny (zmizení fotek / skupiny) přišly bez refresh
        const onVisibility = () => {
            if (typeof document !== 'undefined' && document.visibilityState === 'visible') getReset();
        };
        document.addEventListener('visibilitychange', onVisibility);

        return () => {
            clearInterval(intervalId);
            clearInterval(intervalId2);
            clearInterval(intervalId3);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [refreshTrigger, roomID, effectiveOrg]);

    const rawName = deviceDescription ?? roomName ?? props.roomName;
    const roomDisplayName = (rawName != null && String(rawName).trim() && String(rawName).toLowerCase() !== 'undefined')
        ? String(rawName).trim()
        : (roomID ? `Místnost ${roomID}` : '—');

    useEffect(() => {
        if (typeof document !== 'undefined' && roomDisplayName) {
            document.title = roomDisplayName;
        }
    }, [roomDisplayName]);

    const headerStyle = { backgroundColor, color: roomNameColor };
    const hasMeeting = roomtext != null && roomtext !== '';
    const footerLogo = showLogo && logoHeader && (
        <div className={classes.noMeetingModern_logoWrap}>
            <img src={logoHeader} alt="" />
        </div>
    );
    /* Jednotný layout pro všechny stavy: nahoře název místnosti (barva z nastavení), uprostřed obsah, dole logo */
    const unifiedLayout = (bodyContent) => (
        <div className={classes.noMeetingModern}>
            <header className={classes.noMeetingModern_header} style={headerStyle}>
                <h1 className={classes.noMeetingModern_roomName} style={{ color: roomNameColor }}>{roomDisplayName}</h1>
            </header>
            <div className={classes.noMeetingModern_body}>
                {bodyContent}
            </div>
            <footer className={classes.noMeetingModern_footer}>
                {footerLogo}
            </footer>
        </div>
    );
    const isRadissonBlu = (effectiveOrg || '').toString().trim().toUpperCase() === RADISSON_BLU_ORG_ID.toUpperCase();
    const radissonNoMeetingImageUrl = assetsBaseUrl + RADISSON_BLU_NO_MEETING_IMAGE;

    let noMeeting = unifiedLayout(null);
    const slideshowUrl = slideshowCards.length > 0 ? slideshowCards[slideshowIndex % slideshowCards.length] : null;
    /* Když běží slideshow: pouze fullscreen obrázek, žádný header ani footer */
    let slideshowView = slideshowUrl ? (
        <div className={classes.mainNo}>
            <img
                src={slideshowUrl}
                alt=""
                style={{ width: '100%', height: '100%', objectFit: objectFitSlideshow }}
            />
        </div>
    ) : null;

    // Čas akce: zobrazit jako v kioscích z řetězce (HH:mm), bez timezone konverze – jinak by 9:00 UTC vycházelo na displeji jako 10:00
    let timeLabel = null;
    if (showTimeRange && meetingData && meetingData.dateFrom && meetingData.dateTo) {
        try {
            const sFrom = String(meetingData.dateFrom).trim();
            const sTo = String(meetingData.dateTo).trim();
            const timeFrom = sFrom.length >= 16 ? sFrom.substring(11, 16) : '';
            const timeTo = sTo.length >= 16 ? sTo.substring(11, 16) : '';
            if (timeFrom && timeTo) timeLabel = `${timeFrom} - ${timeTo}`;
        } catch (_) {}
    }

    const meetingBody = (
        <div className={classes.displayMeetingBody} style={{ color: meetingTitleColor }}>
            {showTitle && roomtext && <p>{roomtext}</p>}
            {timeLabel && <div className={classes.displayMeetingTime}>{timeLabel}</div>}
            {logoOrg && <img src={logoOrg} alt="" />}
        </div>
    );
    let meeting = unifiedLayout(meetingBody);

    /* Radisson „no meeting“: obrázek přes celou obrazovku včetně headeru (fullscreen) */
    const radissonNoMeetingView = (
        <div className={classes.mainNo}>
            <img
                src={radissonNoMeetingImageUrl}
                alt=""
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
        </div>
    );

    // Rozhodování: pokud je zapnutá priorita slideshow, má slideshow přednost před meetingem.
    if (slideshowPriority && slideshowView) return <>{slideshowView}</>;
    if (hasMeeting) return <>{meeting}</>;
    if (isRadissonBlu) return <>{radissonNoMeetingView}</>;
    if (slideshowView) return <>{slideshowView}</>;
    return <>{noMeeting}</>;
}
export default RoomFairmont